import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Eyebrow / kicker label (SPEC FE-1 / R2).
 *
 * The signature metabus type treatment: a small wide-tracked UPPERCASE label in
 * primary orange that sits above a heading as a section kicker. Recipe from
 * .metabus/design/metabus-theme-reference.md section 5 (.section-eyebrow):
 * text-xs, font-semibold, uppercase, tracking-[0.18em], text-primary.
 *
 * "the most recognizable metabus type signature" - use it where a small label
 * sits above a heading (a dashboard section kicker, an analytics card-group
 * category label, etc.).
 */
const Eyebrow = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn(
      "text-xs font-semibold uppercase tracking-[0.18em] text-primary",
      className
    )}
    {...props}
  />
))
Eyebrow.displayName = "Eyebrow"

export { Eyebrow }
